import fontcolors from 'admin/helper/fontColorsForEditor';
import PropTypes from 'prop-types';
import c from 'classnames';
import imagePlaceholderDataUri from 'helper/imagePlaceholder';
import $j from 'jquery';
import React from 'react';
import './initFilePicker';
import executeHelper from './redactorHelper';

const loadImage = (url, callback) => {
  const img = new Image();
  img.src = url;
  img.onload = callback;
};

export default class HtmlBlock extends React.Component {
  static contextTypes = {
    getFeatureFlag: PropTypes.func
  };

  componentDidMount() {
    const useFilestackFilePicker =
      this.context.getFeatureFlag && this.context.getFeatureFlag('use-filestack');

    this.props.editable && executeHelper(useFilestackFilePicker);
    if (this.props.editable) {
      this.initChange = true;
      this.redactorEditor = window.$R(this.textArea, {
        plugins: [
          'alignment',
          'filepicker',
          'fontsize',
          /*  'lineheight', */ 'fontfamily',
          'fontcolor',
          'table'
        ],
        // toolbarFixed: false,
        toolbarFixedTopOffset: 47,
        buttons: [
          'html',
          'format',
          'bold',
          'italic',
          'underline',
          'deleted',
          'line',
          'lists',
          'image',
          'file',
          'link',
          'horizontalrule',
          'alignment',
          'filepicker',
          'fontsize',
          /* 'lineheight', */ 'fontfamily',
          'fontcolor',
          'sup',
          'sub'
        ],
        // buttons: ['unorderedlist', 'orderedlist'],
        // deniedTags: ['html', 'head', 'body', 'meta', 'applet', 'script', 'style'],
        // replaceDivs: false,
        imageResizable: true,
        imagePosition: true,
        imageFloatMargin: '15px',
        focus: false,
        callbacks: {
          synced: this.htmlChanged
        },
        fontcolors
      });
      this.redactorEditor.source.setCode(this.props.lesson.items[0].html);
      // setTimeout(() => this.redactorEditor.insert.raw(''), 10);

      // this.redactorEditor.source.setCode(this.props.lesson.items[0].html);
      // this.redactorEditor.code.sync();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.lesson.items[0]._id !== nextProps.lesson.items[0]._id) {
      // this.redactorEditor.destroy();
      this.redactorEditor.source.setCode(nextProps.lesson.items[0].html);
      this.initChange = true;
      // setTimeout(() => this.redactorEditor.insertion.insertRaw(''), 10);
    }
  }

  shouldComponentUpdate(nextProps) {
    if (!nextProps.editable || this.props.lesson.items[0]._id !== nextProps.lesson.items[0]._id) {
      return true;
    }
    return false;
  }

  componentDidUpdate() {
    if (!this.props.editable) {
      this.handleImagesLoadStatus(this.htmlRef);
    }
  }

  componentWillUnmount() {
    $j(this.htmlRef).off('click.external');
  }

  setHtmlRef = ref => {
    this.htmlRef = ref;
    this.handleImagesLoadStatus(this.htmlRef);
  };

  getIfInitChange = () => this.initChange;

  setTextareaRef = ref => (this.textArea = ref);

  handleImagesLoadStatus = htmlRef => {
    if (!htmlRef) {
      return;
    }
    const images = $j(htmlRef).find('img');
    // console.log(images);
    if (images.length > 0) {
      images.not('.loaded').each((i, elem) => {
        if (elem.complete !== true) {
          const origSrc = elem.src;
          loadImage(origSrc, () => {
            elem.src = origSrc;
            elem.style.opacity = 1;
            elem.className += ' loaded';
          });
          elem.style.opacity = 0.3;
          elem.src = imagePlaceholderDataUri;
        }
      });
    }
  };

  /*   editorSync(callback, initChange) {
      return function htmlChanged(html) {
        !initChange() && callback && callback(html);
      };
      // this.htmlChanged(this.code.get());
    } */

  htmlChanged = html => {
    if (this.initChange) {
      this.initChange = false;
      return false;
    }
    const { dispatch, lesson } = this.props;
    const item = lesson.items[0];
    dispatch('UPDATE_ITEM_DATA', {
      _id: item._id,
      html
    });
  };

  renderContent = () => {
    const { lesson, dispatch, editable } = this.props;
    const item = lesson.items[0];

    if (editable) {
      return (
        <textarea
          placeholder="Add content here..."
          ref={this.setTextareaRef}
          id="redactor-placeholder"
          name="redactor-placeholder"
        />
      );
    }
    return (
      <div
        ref={this.setHtmlRef}
        className="redactor-styles redactor-in htmlFamilyContainer"
        dangerouslySetInnerHTML={{ __html: item.html }}
      />
    );
  };

  render() {
    const { editable } = this.props;
    // console.log(editable + 'editable');
    return (
      <div className="block-html">
        <div className={c('redactor-container', { editable, preview: !editable })}>
          {this.renderContent()}
        </div>
      </div>
    );
  }
}
